export { default as FontSizeControl } from './font-size-control';